module.exports = __webpack_public_path__ + "static/media/quiz-welcome-polarbear.11512378.png";